/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      setTimeout(() => {
        const buttons = Array.from(this.querySelectorAll('button'));
        const sectionHeader = this.closest('.section-header');
        if (!sectionHeader) return;
        const links = sectionHeader.querySelectorAll('.linked-to-tab');
        this.target = this.dataset.target;
        this.slider = document.getElementById(this.target);

        // Initialize or update Flickity with loop on mobile
        this.initializeSlider();

        buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            this.toggleButtons(buttons, i);
            this.toggleLinks(links, i);
            if (button.dataset.collection) {
              this.toggleCollection(button.dataset.collection);
            }
            event.preventDefault();
          });
        });
        
        window.addEventListener('resize', () => {
          if (!this.slider) return;
          this.updateLoopSetting();
        });
        
        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const index = buttons.indexOf(event.target);
            if (index !== -1) {
              buttons[index].dispatchEvent(new Event('click'));
            }
          });
        }
      }, 10);
    }

    initializeSlider() {
      if (!this.slider) return;
      
      // Wait for Flickity to be initialized
      const checkFlickity = setInterval(() => {
        const flkty = Flickity.data(this.slider);
        if (flkty) {
          clearInterval(checkFlickity);
          this.updateLoopSetting();
        }
      }, 100);
      
      // Clear interval after 5 seconds if Flickity is not found
      setTimeout(() => clearInterval(checkFlickity), 5000);
    }

    updateLoopSetting() {
      if (!this.slider) return;
      const flkty = Flickity.data(this.slider);
      if (!flkty) return;
      
      const isMobile = window.innerWidth < 768;
      
      // Only update if the wrapAround setting needs to change
      if (isMobile && !flkty.options.wrapAround) {
        flkty.options.wrapAround = true;
        flkty.reloadCells();
        flkty.resize();
      } else if (!isMobile && flkty.options.wrapAround) {
        flkty.options.wrapAround = false;
        flkty.reloadCells();
        flkty.resize();
      } else {
        flkty.resize();
      }
    }

    toggleButtons(buttons, index) {
      buttons.forEach((button) => button.classList.remove('active'));
      buttons[index].classList.add('active');
    }

    toggleLinks(links, index) {
      if (links.length) {
        links.forEach((link) => link.classList.remove('active'));
        links[index].classList.add('active');
      }
    }

    toggleCollection(handle) {
      const slider = document.getElementById(this.target);
      if (!slider) return;
      const products = slider.querySelectorAll(`.columns:not([data-collection="${handle}"])`);
      const activeProducts = slider.querySelectorAll(`[data-collection="${handle}"]`);
      const flkty = Flickity.data(slider);

      products.forEach((product) => { 
        product.classList.remove('carousel__slide'); 
        slider.append(product); 
      });
      activeProducts.forEach((product) => product.classList.add('carousel__slide'));

      flkty.insert(activeProducts);
      flkty.reloadCells();
      flkty.select(0, 0, 1);
      
      // Update loop after collection change
      setTimeout(() => this.updateLoopSetting(), 50);
    }
  }
  customElements.define('collection-tabs', CollectionTabs);
}